// src/features/infoscreens/Routes.jsx
import { Navigate, Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import { INFOSCREENS_LIST_PATH } from './paths';
import CreateInfoscreenPage from './pages/CreateInfoscreenPage';
import InfoscreenDetailsPage from './pages/InfoscreenDetailsPage';
import EditInfoscreenPage from './pages/EditInfoscreenPage';

export const InfoscreensRoutes = () => (
  <Route path="infoscreens">
    <Route index element={<Navigate to={INFOSCREENS_LIST_PATH} replace />} />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="infoscreen:create">
          <CreateInfoscreenPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":infoscreenId"
      element={
        <ProtectedRoute requiredScope="infoscreen:read">
          <InfoscreenDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":infoscreenId/edit"
      element={
        <ProtectedRoute requiredScope="infoscreen:update">
          <EditInfoscreenPage />
        </ProtectedRoute>
      }
    />
  </Route>
);